;(function () {
  'use strict'

  angular
    .module('contrast.settings.groups')
    .controller('BaseGroupCtrl', BaseGroupCtrl)

  function BaseGroupCtrl(
    $scope,
    $q,
    $translate,
    ErrorService,
    ProfileService,
    RoleFactory,
    UserFactory,
    ApplicationFactory,
    ROLE_NOACCESS
  ) {
    'ngInject'

    var translGlobal = {}

    var me
    var allObject = {}
    var onboardObject = {}
    var emptyRow = {}

    this.$onInit = function () {
      translGlobal = {
        title_allApplications: $translate.instant('title_allApplications'),
        title_onboardApplications: $translate.instant(
          'title_onboardApplications'
        )
      }

      me = this
      allObject = {
        name: translGlobal.title_allApplications,
        primary: false,
        app_id: 0
      }
      onboardObject = {
        name: translGlobal.title_onboardApplications,
        primary: false,
        app_id: 'onboard'
      }
      emptyRow = {
        role: undefined,
        apps: [],
        selected_apps: [],
        available_apps: []
      }
      angular.extend(me, {
        init: init,
        addException: addException,
        removeCurrentUser: removeCurrentUser,
        _updateAvailableApps: _updateAvailableApps
      })

      angular.extend($scope, {
        currentUser: ProfileService.getUid(),
        isEdit: false,
        loadPromise: null,
        editable: true,
        saving: false,
        checking: false,
        app_roles: [],
        limit: 6,
        users: [],
        apps: [],
        group: {
          users: [],
          exceptions: []
        },
        validation: {
          unique: true,
          setName: false,
          pristine: false,
          exceptions: false
        }
      })

      angular.extend($scope, {
        addException: addException,
        removeException: removeException,
        onSelectApp: onSelectApp,
        onRemoveApp: onRemoveApp,

        removeMember: removeMember,
        addMember: addMember,
        format: format,
        showAllUsers: showAllUsers,

        onSelectRole: onSelectRole,
        isValid: isValid
      })
    }

    function init() {
      return $q.all([_getRoles(), _getUsers(), _getApps()])
    }

    function addException() {
      $scope.group.exceptions.push(angular.copy(emptyRow))
      _updateAvailableApps()
    }

    function removeException(exception) {
      $scope.validation.pristine = true
      var idx = $scope.group.exceptions.indexOf(exception)
      if (idx > -1) {
        $scope.group.exceptions.splice(idx, 1)
      }

      if ($scope.group.exceptions.length == 0) {
        $scope.group.exceptions.push(angular.copy(emptyRow))
      }

      _updateAvailableApps()
      _checkExceptions()
    }

    function onSelectApp(item, row) {
      $scope.validation.pristine = true
      if (item.app_id === allObject.app_id) {
        row.apps = [allObject]
        row.selected_apps = [allObject]
        _updateAvailableApps()
      } else if (item.app_id === onboardObject.app_id) {
        row.apps = [onboardObject]
        row.selected_apps = [onboardObject]
        if (!row.role) {
          row.role = $scope.app_roles[0]
        }
        _updateAvailableApps()
      } else {
        _removeIfSelected(allObject.app_id, row)
        _removeIfSelected(onboardObject.app_id, row)

        row.selected_apps.push(item)
      }

      row.available_apps = _.difference(row.available_apps, row.selected_apps)
      _consolidateDisabledApps()
      _checkExceptions()
    }

    function _removeIfSelected(id, row) {
      var index = _.findIndex(row.selected_apps, function (app) {
        return app.app_id == id
      })
      if (index !== -1) {
        row.apps.splice(index, 1)
        row.selected_apps.splice(index, 1)
        _updateAvailableApps()
      }
    }

    function onRemoveApp(item, row) {
      $scope.validation.pristine = true
      if (row.apps.length == 0 && $scope.group.exceptions.length > 1) {
        $scope.group.exceptions = _.without($scope.group.exceptions, row)
      }

      _updateAvailableApps()
      _consolidateDisabledApps()
      _checkExceptions()
    }

    function removeMember(member) {
      $scope.validation.pristine = true
      var idx = $scope.group.users.indexOf(member)
      if (idx > -1) {
        $scope.group.users.splice(idx, 1)
        $scope.users.push(member)
      }
    }

    function addMember(item) {
      $scope.validation.pristine = true
      var idx = $scope.users.indexOf(item)
      if (idx > -1) {
        $scope.group.users.unshift(item)
        $scope.users.splice(idx, 1)
        $scope.model.member = ''
      }
    }

    function format(model) {
      return model ? model.first_name + ' ' + model.last_name : ''
    }

    function onSelectRole() {
      $scope.validation.pristine = true
      _checkExceptions()
    }

    function isValid() {
      return (
        $scope.validation.unique == true &&
        $scope.validation.setName == true &&
        $scope.validation.pristine &&
        (!$scope.editable || $scope.validation.exceptions)
      )
    }

    function _getRoles() {
      return RoleFactory.getRoles().then(function (response) {
        let orgAuditRoleIndex = -1
        var roles = response.data.groups
        $scope.app_roles = angular.copy(roles)
        $scope.app_roles.push(ROLE_NOACCESS)
        orgAuditRoleIndex = $scope.app_roles.findIndex(
          (role) => role.name === 'org_auditor'
        )
        if (orgAuditRoleIndex !== -1) {
          $scope.app_roles.splice(orgAuditRoleIndex, 1)
        }
      }, ErrorService.processError)
    }

    function _getUsers() {
      return UserFactory.getUsersBase(false, true).then(function (response) {
        $scope.users = response.data.users
      })
    }

    function _getApps() {
      return ApplicationFactory.getApplicationBase(false, '', true).then(
        function (response) {
          response.data.applications.unshift(onboardObject)
          response.data.applications.unshift(allObject)

          _.each(response.data.applications, function (app) {
            _.extend(app, { disabled: false })
          })

          $scope.apps = response.data.applications

          _updateAvailableApps()
        },
        function (response) {
          ErrorService.processError(response)
        }
      )
    }

    function _updateAvailableApps() {
      var newApps = angular.copy($scope.apps)

      _.each(newApps, function (app) {
        _.extend(app, { disabled: false })
      })

      _.each($scope.group.exceptions, function (appException) {
        appException.available_apps = newApps
      })

      _toggleChildAppsAppExceptions()
      _consolidateDisabledApps()
    }

    function _toggleChildAppsAppExceptions() {
      angular.forEach($scope.group.exceptions, function (appException) {
        var removeChildApps = []
        appException.child_apps = []

        angular.forEach(appException.apps, function (selectedApp) {
          if (selectedApp.child) {
            appException.child_apps.push(selectedApp)
            removeChildApps.push(selectedApp)
          }
        })

        appException.apps = _.difference(appException.apps, removeChildApps)
      })
      _consolidateChildAppsAppExceptions()
    }

    function _consolidateChildAppsAppExceptions() {
      angular.forEach($scope.group.exceptions, function (appException) {
        angular.forEach(appException.apps, function (selectedApp) {
          if (selectedApp.child) {
            var selectedPrimaryApp = _.find(appException.apps, {
              app_id: selectedApp.parent_app_id
            })
            if (selectedPrimaryApp) {
              appException.apps = _.without(appException.apps, selectedApp)
            }
          }
        })
      })
    }

    function _consolidateDisabledApps() {
      var primarySelectedApps = []
      var removeSelectedApps = []

      _.each($scope.group.exceptions, function (appExecution) {
        _.each(appExecution.apps, function (selectedApp) {
          removeSelectedApps.push(selectedApp)
        })
      })

      _.each($scope.group.exceptions, function (appExecution) {
        _.each(primarySelectedApps, function (primarySelectedApp) {
          var primaryAvailableApp = _.find(appExecution.available_apps, {
            app_id: primarySelectedApp.app_id
          })
          if (primaryAvailableApp) {
            primaryAvailableApp.disabled = true
          }
        })

        _.each(removeSelectedApps, function (removeSelectedApp) {
          var removeAvailableApp = _.find(appExecution.available_apps, {
            app_id: removeSelectedApp.app_id
          })
          if (removeAvailableApp) {
            appExecution.available_apps = _.without(
              appExecution.available_apps,
              removeAvailableApp
            )
          }
        })
      })
    }

    function _checkExceptions() {
      $scope.validation.exceptions = false
      _.each($scope.group.exceptions, function (appExecution) {
        if (
          angular.isDefined(appExecution.role) &&
          appExecution.apps.length > 0
        ) {
          $scope.validation.exceptions = true
        }
      })
    }

    function showAllUsers() {
      $scope.limit = 'Infinity'
    }

    function removeCurrentUser() {
      var idx = _.findIndex($scope.users, function (user) {
        return user.uid == $scope.currentUser
      })
      if (idx > -1) {
        $scope.users.splice(idx, 1)
      }
    }
  }
})()
